import VideoSelectionInputModal from './toolbar/videoSelectionInputModal.js';
import VideoSettings from './toolbar/VideoSettings.js';
import 'prop-types';
import 'react';
import 'wix-rich-content-ui-components';
import 'wix-rich-content-editor-common';
import 'wix-rich-content-common';
import './style-inject.es-746bb8ed.js';
import 'react-player';
import './types.js';
import 'wix-rich-content-plugin-commons';
import './toolbar/videoPluginService.js';
import 'lodash';
import 'classnames';
import './toolbar/ControlsSection.js';

const Modals = {
  VIDEO_SELECTION_INPUT: "video-selection-input",
  VIDEO_SETTINGS: "video-settings"
};
const ModalsMap = {
  [Modals.VIDEO_SELECTION_INPUT]: VideoSelectionInputModal,
  [Modals.VIDEO_SETTINGS]: VideoSettings
};

export { Modals, ModalsMap };
//# sourceMappingURL=modals.js.map
